import {
  CHANGED_ELSEWHERE,
  GENERIC_ERROR,
  messageFor,
  toFormErrors as toFormErrorsWith,
  withoutErrorsFor as withoutErrorsForWith,
  type FormErrors,
} from '../../lib/formErrors'

/**
 * Which input each rejection belongs to on the broker form.
 *
 * The domain never names a field — it names the rule that broke, and a rule belongs
 * to exactly one input on this form. The mechanics live in lib/formErrors; what is
 * broker-specific is only this map.
 */
const FIELD_BY_CODE: Record<string, string> = {
  broker_name_required: 'name',
  broker_name_invalid: 'name',
  broker_name_too_long: 'name',
  mc_number_invalid: 'mcNumber',
  broker_duplicate_mc_number: 'mcNumber',
  usdot_number_invalid: 'usdotNumber',
  broker_duplicate_usdot_number: 'usdotNumber',
  broker_tax_id_too_long: 'taxId',
  broker_bond_negative: 'bondAmount',
  money_too_large: 'bondAmount',
  broker_credit_rating_too_long: 'creditRating',
  broker_credit_rating_invalid: 'creditRating',
  address_street_required: 'line1',
  address_street_too_long: 'line1',
  address_unit_too_long: 'line2',
  address_city_required: 'city',
  address_city_too_long: 'city',
  address_state_invalid: 'state',
  address_zip_invalid: 'postalCode',
  address_zip_state_mismatch: 'postalCode',
  phone_invalid: 'phone',
  broker_email_invalid: 'email',
}

/**
 * Rules about a relationship between two fields rather than about one of them:
 * editing either side clears the complaint.
 */
const CLEARED_BY: Record<string, readonly string[]> = {
  address_zip_state_mismatch: ['state', 'postalCode'],
}

export { CHANGED_ELSEWHERE, GENERIC_ERROR, messageFor }
export type { FormErrors }

export function toFormErrors(caught: unknown): FormErrors {
  return toFormErrorsWith(caught, FIELD_BY_CODE)
}

export function withoutErrorsFor(errors: FormErrors, editedField: string): FormErrors {
  return withoutErrorsForWith(errors, editedField, CLEARED_BY)
}
